import { Col, Row, Select } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import {
  ListCreditsSupplierQuery,
  SupplierTypeCredit,
} from '@/core/domain/people/Suppliers/Suppliers.types';

interface Props extends ExtraFiltersProps<ListCreditsSupplierQuery> {
  isItems?: boolean;
}

function SupplierCreditListFilters({
  queryParams,
  setQueryParams,
  isItems,
}: Props) {
  const SupplierTypeCreditOptions = [
    {
      value: SupplierTypeCredit.credit,
      label: 'Crédito',
    },
    {
      value: SupplierTypeCredit.debit,
      label: 'Débito',
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {!isItems && (
        <>
          <Col lg={4} span={24}>
            <Select
              allowClear
              value={queryParams?.supplierCreditType}
              onChange={(value) =>
                setQueryParams((prev) => ({
                  ...prev,
                  supplierCreditType: value,
                }))
              }
              style={{ width: '100%' }}
              placeholder="Mostrar apenas:"
              options={SupplierTypeCreditOptions}
            />
          </Col>
        </>
      )}

      <Col lg={4} span={24}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default SupplierCreditListFilters;
